import React from 'react';
import Cart from '../components/Cart';

const CartPage = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-8">Shopping Cart</h1>
      <Cart />
    </div>
  );
};

export default CartPage;